import React, { ChangeEvent, FC, Fragment, useEffect, useState } from 'react';
import { Box, Button, Card, Grid, InputAdornment, TablePagination, TextField, Tooltip, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { withStyles } from '@mui/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CustomerToggleModal from './CustomerToggleModal';
import SegmentToggleModal from './SegmentToggleModal';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import {
  deleteCustomer,
  deleteSegment,
  deleteStakeholder,
  getCountries,
  getSegments,
  searchSegments
} from 'src/services/projectService';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import { changeStringLength } from 'src/utils/stringFormat';
import StakeholderToggleModal from './StakeholderToggleModal';
import { useDispatch } from 'react-redux';
import { AppActions } from 'src/store/AppReducer';
import { useNavigate } from 'react-router';
import { useAppSelector } from 'src/hooks/hooks';
import SnackBar from 'src/components/SnackBar/SnackBar';

interface SegmentRowsProps {
  permissions: any;
}

const applyFilters = (segments: any[]): any[] => {
  return segments.filter((employeeStatus) => {
    let matches = true;
    return matches;
  });
};

const applyPagination = (
  segments: any[],
  page: number,
  limit: number
): any[] => {
  return segments.slice(page * limit, page * limit + limit);
};


const SegmentRows: FC<SegmentRowsProps> = ({ permissions }) => {
  
  const [segPermissions, setSgPermissions] = useState([]);

  useEffect(() => {
      if(permissions.length != 0){
      }
      setSgPermissions(permissions);
  },[permissions]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const CustomTableRow = withStyles({
    root: {
      backgroundColor: '#E6E9FF !important',
      height: '3rem'
    }
  })(Card);

  const CustomTableColumn = withStyles({
    root: {
      height: '3rem'
    }
  })(Card);

  const PrimaryTextTypography = withStyles({
    root: {
      color: '#0096FF',
      cursor: 'pointer'
    }
  })(Typography);

  const [segments, setSegments] = useState([]);
  const [countries, setCountries] = useState([]);

  const getTableData = () => {
    dispatch(AppActions.showLoader());

    getSegments().then((res) => {
      const datas = res.data;

      const sortedData = datas.sort((a, b) => b.code.localeCompare(a.code));

      setSegments((sortedData as any) || []);
      dispatch(AppActions.hideLoader());
    });
  };

  useEffect(() => {
    getTableData();
    getCountries().then((res) => {
      const arr = res.data;
      const simplifiedArr = arr.map((con) => con?.name);
      const sortedData = simplifiedArr.sort((a, b) => a.localeCompare(b));
      setCountries(sortedData);
    });
  }, []);

  const [expand, setExpand] = useState(false);
  const [expandedCode, setExpandedCode] = useState('');

  const [expandCustomer, setExpandCustomer] = useState(false);
  const [expandedCodeCustomer, setExpandedCodeCustomer] = useState('');

  const expandTable = (code: string) => {
    setExpand(!expand);
    setExpandCustomer(false);
    if (expandedCode !== code) {
      setExpand(true);
    }
    setExpandedCode(code);
  };

  const expandTableCustomer = (code: string) => {
    setExpandCustomer(!expandCustomer);
    if (expandedCodeCustomer !== code) {
      setExpandCustomer(true);
    }
    setExpandedCodeCustomer(code);
  };

  const [openCreateEdit, setOpenCreateEdit] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState<any>({});

  const toggleCreateEdit = () => {
    setOpenCreateEdit(!openCreateEdit);
  };

  const [openCustomers, setOpenCustomers] = useState(false);
  const [customerEdit, setCustomerEdit] = useState(false);
  const [editDataCustomer, setEditDataCustomer] = useState<any>({});
  const [customerLength, setCustomerLength] = useState(0);
  const [segmentId, setSegmentId] = useState('');
  const [segmentName, setSegmentName] = useState('');
  const [customerName, setCustomerName] = useState('');

  const toggleCustomersAdd = () => {
    setOpenCustomers(!openCustomers);
  };

  const [openStakeHolders, setOpenStakeHolders] = useState(false);
  const [stakeholdersEdit, setStakeholdersEdit] = useState(false);
  const [editDataStakeholder, setEditDataStakeholder] = useState<any>({});
  const [stakeholderLength, setStakeholderLength] = useState(0);
  const [customerID, setCustomerID] = useState('');

  const toggleStakeholdersAdd = () => {
    setOpenStakeHolders(!openStakeHolders);
  };

  const [openConfirmationDelete, setOpenConfirmationDelete] = useState(false);
  const [openConfirmationCustomerDelete, setOpenConfirmationCustomerDelete] =
    useState(false);
  const [
    openConfirmationStakeholderDelete,
    setOpenConfirmationStakeholderDelete
  ] = useState(false);

  const toggleConfirmationDelete = () => {
    setOpenConfirmationDelete(!openConfirmationDelete);
  };

  const toggleConfirmationCustomerDelete = () => {
    setOpenConfirmationCustomerDelete(!openConfirmationCustomerDelete);
  };

  const toggleConfirmationStakeholderDelete = () => {
    setOpenConfirmationStakeholderDelete(!openConfirmationStakeholderDelete);
  };
  const { isLoading } = useAppSelector((state) => state.appReducer);
  const [segmentDeleteID, setSegmentDeleteID] = useState('');
  const [customerDeleteID, setCustomerDeleteID] = useState('');
  const [stakeholderDeleteID, setStakeholderDeleteID] = useState('');

  const deleteSegmentFunc = () => {
    deleteSegment(segmentDeleteID)
      .then(() => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: 'You have deleted the segment successfully.',
            severity: 'success'
          })
        );
        getTableData();
        toggleConfirmationDelete();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const deleteCustomerFunc = () => {
    deleteCustomer(customerDeleteID)
      .then(() => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: 'You have deleted the client successfully.',
            severity: 'success'
          })
        );
        getTableData();
        toggleConfirmationCustomerDelete();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const deleteStakeholderFunc = () => {
    deleteStakeholder(stakeholderDeleteID)
      .then(() => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: 'You have deleted the stakeholder successfully.',
            severity: 'success'
          })
        );
        getTableData();
        toggleConfirmationStakeholderDelete();
      })
      .catch((error) => {
        if (
          error?.response?.data ===
          'An error occurred while saving the entity changes. See the inner exception for details.'
        ) {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message:
                ' You cannot delete this stakeholder since it has associated projects.',
              severity: 'error'
            })
          );
          toggleConfirmationStakeholderDelete();
        } else {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: error.response.data,
              severity: 'error'
            })
          );
          toggleConfirmationStakeholderDelete();
        }
      });
  };

  const [searchKeywords, setSearchKeywords] = useState('');

  const nameChange = (event) => {
    setSearchKeywords(event.target.value);
  };

  const searchGroupsAll = async (keyword: string) => {
    dispatch(AppActions.showLoader());
    const result = await searchSegments(keyword);
    setPage(0);
    setSegments(result?.data);
    dispatch(AppActions.hideLoader());
  };

  useEffect(() => {
    if (searchKeywords.length > 0) {
      searchGroupsAll(searchKeywords);
    }
    if (searchKeywords.length === 0) {
      getTableData();
    }
  }, [searchKeywords]);

  const [snackBarOpenS, setSnackBarOpenS] = useState(false);
  const [snackbarSeverityS, setSnackbarSeverityS] = useState('');
  const [snackBarMessageS, setSnackBarMessageS] = useState('');
  
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);

  const filteredSegments = applyFilters(segments);

  const paginatedSegments = applyPagination(filteredSegments, page, limit);

  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };

  const getCustomersInSegments = (stat) => {
    const customers = stat?.customers;
    const sortedData = customers.sort((a, b) => b.code.localeCompare(a.code));
    return (
      sortedData?.length > 0 ? (
        sortedData.map((customer, i) => (
          <Fragment>
            <CustomTableColumn
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '1rem 2rem',
                borderBottom: '2px solid #EAEDED',
                borderRadius: '0',
                boxShadow: 'rgba(0, 0, 0, 0.1) 1.95px 0px 0px',
                borderLeft: '1px solid #D3D3D3',
                background: '#F4F6F7'
              }}
              key={customer.id}
            >
              <Typography style={{ fontSize: '11px', width: '10rem', wordWrap: 'break-word' }}>
                {customer.name}
              </Typography>
              <Typography
                style={{
                  fontSize: '11px',
                  borderRadius: '4px',
                  width: '8rem'
                }}
              >
                {customer.code}
              </Typography>
              <Typography
                style={{
                  fontSize: '11px',
                  borderRadius: '4px',
                  width: '8rem'
                }}
              >
                {customer.country}
              </Typography>
              <Typography
                style={{
                  fontSize: '11px',
                  borderRadius: '4px',
                  width: '8rem'
                }}
              >
                {customer.industry || '-'}
              </Typography>
              <Typography
                style={{
                  fontSize: '11px',
                  borderRadius: '4px',
                  width: '10rem'
                }}
              >
                {changeStringLength(customer.engagementLead, 20)
                  ? changeStringLength(customer.engagementLead, 20)
                  : customer.engagementLead}
              </Typography>
              <PrimaryTextTypography
              id={"a-navigate-" + i}
              onClick={() => {
                navigate(
                  `/project-details/${customer.id}?name=${customer.name}`
                );
              }}
              style={{
                fontSize: '11px',
                width: '10rem'
              }}
            >
              View Projects
            </PrimaryTextTypography>
              {permissions.some(
                                (perm) =>
                                  perm.name === 'Edit Customer' && perm.value === true
                              ) && 

                <>
              <div style={{ display: 'flex', marginLeft: 'auto'}}>
              <Tooltip title="Edit" placement="top" > 
              <EditIcon
                  id={"btn-setEditDataCustomer-" + i}
                  onClick={() => {
                    setCustomerEdit(true);
                    setSegmentId(stat.id);
                    setEditDataCustomer(customer);
                    toggleCustomersAdd();
                    setSegmentName(stat.name);
                  }}
                  style={{
                    fontSize: '17px',
                    cursor: 'pointer'
                  }}
                />
              </Tooltip>
              <Tooltip title="Delete" placement="top" > 
              <DeleteOutlineIcon
                  id={"btn-toggleConfirmationCustomerDelete-" + i}
                  onClick={() => {
                    if (customer?.stakeholders?.length === 0) {
                      setCustomerDeleteID(customer.id);
                      toggleConfirmationCustomerDelete();
                    } else {
                      dispatch(
                        AppActions.toggleSnackBarOpen({
                          message:
                            'This client has assigned  stakeholders. Please remove the stakeholders before deleting this client.',
                          severity: 'error'
                        })
                      );
                    }
                  }}
                  style={{
                    fontSize: '17px',
                    cursor: 'pointer'
                  }}
                />
              </Tooltip>
              </div>
                </>
              }
              {expandCustomer && expandedCodeCustomer === customer.id ? (
                <ExpandLessIcon
                  id={"btn-expandTableCustomer-lessIcon-" + i}
                  onClick={() => expandTableCustomer(customer.id)}
                  style={{
                    fontSize: '27px',
                    cursor: 'pointer',
                    height: 'fit-content'
                  }}
                />
              ) : (
                <ExpandMoreIcon
                id={"btn-expandTableCustomer-moreIcon-" + i}
                  onClick={() => expandTableCustomer(customer.id)}
                  style={{
                    fontSize: '27px',
                    cursor: 'pointer'
                  }}
                />
              )}
            </CustomTableColumn>
            {expandCustomer && expandedCodeCustomer === customer.id && (
              <Fragment>
                <CustomTableColumn
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '1rem 3rem',
                    borderBottomLeftRadius: '0',
                    borderBottomRightRadius: '0',
                    borderTopLeftRadius: '0',
                    borderTopRightRadius: '0',
                    boxShadow: 'rgba(0, 0, 0, 0.1) 1.95px 0px 0px',
                    borderLeft: '1px solid #D3D3D3',
                    background: '#F8F9F9'
                  }}
                >
                  <Button
                    id={"btn-toggleStakeholdersAdd-" + i}
                    onClick={() => {
                      setStakeholdersEdit(false);
                      setSegmentId(stat.id);
                      setCustomerID(customer.id);
                      toggleStakeholdersAdd();
                      setSegmentName(stat.name);
                      setCustomerName(customer.name);
                    }}
                    sx={{
                      mt: { xs: 2, md: 0 },
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}
                    variant="outlined"
                    startIcon={<AddTwoToneIcon fontSize="small" />}
                    style={{
                      height: '1.75rem',
                      marginLeft: 'auto'
                    }}
                  >
                    Create New
                  </Button>
                </CustomTableColumn>
                <SnackBar
                snackBarOpen={snackBarOpenS}
                setSnackBarOpen={setSnackBarOpenS}
                snackBarMessage={snackBarMessageS}
                snackbarSeverity={snackbarSeverityS}
                />
                  <Card
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '1rem 3rem',
                      background: 'rgba(186, 206, 229, 0.2)',
                      borderRadius: '0',
                      boxShadow: 'rgba(0, 0, 0, 0.1) 1.95px 0px 0px',
                      borderLeft: '1px solid #D3D3D3'
                    }}
                  >
                    <Typography
                      style={{
                        color: '#232C68',
                        fontWeight: '700',
                        fontSize: '11px',
                        width: '10rem'
                      }}
                    >
                      {'Stakeholder Name'}
                    </Typography>
                    <Typography
                      style={{
                        color: '#232C68',
                        fontWeight: '700',
                        fontSize: '11px',
                        width: '10rem'
                      }}
                    >
                      {'Designation'}
                    </Typography>
                    <Typography
                      style={{
                        color: '#232C68',
                        fontWeight: '700',
                        fontSize: '11px',
                        width: '12rem'
                      }}
                    >
                      {'Email'}
                    </Typography>
                    <Typography
                      style={{
                        color: '#232C68',
                        fontWeight: '700',
                        fontSize: '11px',
                        width: '11rem'
                      }}
                    >
                      {'Contact Number'}
                    </Typography>
                    <Typography
                      style={{
                        color: '#232C68',
                        fontWeight: '700',
                        fontSize: '11px',
                        marginLeft: 'auto'
                      }}
                    >
                      {'Actions'}
                    </Typography>
                  </Card>
                {customer?.stakeholders?.length > 0 ? (
                  customer.stakeholders.map((stakeholder, i) => (
                    <Fragment>
                      <CustomTableColumn
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '1rem 3rem',
                          borderBottom: '2px solid #EAEDED',
                          borderRadius: '0',
                          boxShadow: 'rgba(0, 0, 0, 0.1) 1.95px 0px 0px',
                          borderLeft: '1px solid #D3D3D3',
                          background: '#F4F6F7',
                        }}
                        key={stakeholder?.designationId}
                      >
                        <Typography
                          style={{
                            fontSize: '11px',
                            width: '10rem',
                            wordWrap: 'break-word'
                          }}
                        >
                          {stakeholder.name}
                        </Typography>
                        <Typography
                          style={{
                            fontSize: '11px',
                            borderRadius: '4px',
                            width: '10rem'
                          }}
                        >
                          {stakeholder.designation}
                        </Typography>
                        <Typography
                          style={{
                            fontSize: '11px',
                            borderRadius: '4px',
                            width: '12rem'
                          }}
                        >
                          {stakeholder.email}
                        </Typography>
                        <Typography
                          style={{
                            fontSize: '11px',
                            borderRadius: '4px',
                            width: '11rem'
                          }}
                        >
                          {stakeholder.contactNumber || '-'}
                        </Typography>
                        <div style={{ marginLeft: 'auto'}}>
                        <Tooltip title="Edit" placement="top" > 
                        <EditIcon
                            id={"btn-setEditDataStakeholder-" + i}
                            onClick={() => {
                              setStakeholdersEdit(true);
                              setEditDataStakeholder(stakeholder);
                              setSegmentId(stat.id);
                              setCustomerID(customer.id);
                              setStakeholderLength(
                                customer?.stakeholders?.length
                              );
                              toggleStakeholdersAdd();
                              setSegmentName(stat.name);
                              setCustomerName(customer.name);
                            }}
                            style={{
                              fontSize: '17px',
                              cursor: 'pointer'
                            }}
                          />
                        </Tooltip>
                        <Tooltip title="Delete" placement="top" >  
                        <DeleteOutlineIcon
                            id={"btn-toggleConfirmationStakeholderDelete-" + i}
                            onClick={() => {
                              setStakeholderDeleteID(stakeholder.id);
                              toggleConfirmationStakeholderDelete();
                            }}
                            style={{
                              fontSize: '17px',
                              cursor: 'pointer'
                            }}
                          />
                        </Tooltip>
                        </div>
                      </CustomTableColumn>
                    </Fragment>
                  ))
                ) : (
                  <CustomTableColumn>
                    <Typography
                      style={{
                        fontSize: '15px',
                        fontWeight: 'bold',
                        margin: '1rem',
                        textAlign: 'center'
                      }}
                      variant="body2"
                    >
                      No Records Found
                    </Typography>
                  </CustomTableColumn>
                )
                  }
              </Fragment>
            )}
          </Fragment>
        ))
      ) : (
        <CustomTableColumn>
          <Typography
              style={{
                fontSize: '15px',
                fontWeight: 'bold',
                margin: '1rem',
                textAlign: 'center'
              }}
              variant="body2"
            >
              No Records Found
            </Typography>
          </CustomTableColumn>
      )
      
    );
  };

  return (
    <Fragment>
      <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
        <Grid item>
          <Typography
            style={{
              marginLeft: '0px',
              fontWeight: '700',
              fontSize: '16px',
              fontFamily:
                'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
            }}
          >
            Segments
          </Typography>
        </Grid>
        <Grid item>

            {permissions.some(
                (perm) =>
                  perm.name === 'Edit Segments' && perm.value === true
              ) && 

                <>
          <Button
            id="btn-toggleCreateEdit"
            onClick={() => {
              setIsEdit(false);
              toggleCreateEdit();
            }}
            sx={{
              mt: { xs: 2, md: 0 },
              fontSize: '11px',
              fontWeight: 'normal'
            }}
            variant="contained"
            startIcon={<AddTwoToneIcon fontSize="small" />}
            style={{ height: '1.75rem' }}
          >
            Create New
            </Button>
                </>
        }

        </Grid>
      </Grid>
      <Card style={{ marginBottom: -18,}}>
      <Grid
          container
          style={{
            justifyContent: 'space-between',
            padding: '1rem',
          }}
          spacing={2}
        >
          <Grid item xs={6}>
            <TextField
              id="segmentNameSearch"
              name="segmentNameSearch"
              sx={{ width: 320, mr: 2 }}
              size="small"
              placeholder="Segment Name"
              onChange={(e) => nameChange(e)}
              InputProps={{
                style: { fontSize: '12px', height: '1.75rem' },
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      sx={{ color: '#d3d3d3' }}
                      style={{ fontSize: '15px' }}
                    />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
        </Grid>
      </Card>
      <Grid sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
        <CustomTableRow
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '1rem'
          }}
        >
          <Typography
            style={{
              color: '#232C68',
              fontWeight: '700',
              fontSize: '11px',
              width: '10rem'
            }}
          >
            {'Segment Name'}
          </Typography>
          <Typography
            style={{
              color: '#232C68',
              fontWeight: '700',
              fontSize: '11px',
              width: '10rem'
            }}
          >
            {'Segment Code'}
          </Typography>
          <Typography
            style={{
              color: '#232C68',
              fontWeight: '700',
              fontSize: '11px',
              width: '25rem'
            }}
          >
            {'Description'}
          </Typography>
          <Typography
            style={{
              color: '#232C68',
              fontWeight: '700',
              fontSize: '11px',
              marginLeft: 'auto',
              marginRight: '1rem'
            }}
          >
            {'Actions'}
          </Typography>
        </CustomTableRow>
        {paginatedSegments &&
          paginatedSegments?.length > 0 &&
          paginatedSegments?.map((stat, i) => (
            <Grid key={stat.segmentCode}>
              <CustomTableColumn
                style={{
                  marginTop: '1rem',
                  display: 'flex',
                  alignItems: 'center',
                  padding: '1rem',
                  boxShadow: `${
                    expand &&
                    expandedCode === stat.code &&
                    'rgba(0, 0, 0, 0.45) 0px 25px 20px -20px'
                  }`
                }}
              >
                <Typography
                  style={{
                    fontSize: '11px',
                    width: '10rem',
                    wordBreak: 'break-all',
                    paddingRight: '0.1rem'
                  }}
                >
                  {stat.name}
                </Typography>
                <Typography style={{ fontSize: '11px', width: '10rem' }}>
                  {stat.code}
                </Typography>
                <Typography style={{ fontSize: '11px', width: '25rem' }}>
                  {stat.description || '-'}
                </Typography>
                <div style={{ marginLeft: 'auto'}}>
                {permissions.some(
                                (perm) =>
                                  perm.name === 'Edit Segments' && perm.value === true
                              ) && 

                <>
                            <Tooltip title="Edit" placement="top" > 
                <EditIcon
                    id={"btn-toggleCreateEdit-" + i}
                    onClick={() => {
                      setIsEdit(true);
                      toggleCreateEdit();
                      setEditData(stat);
                    }}
                    style={{
                      fontSize: '17px',
                      cursor: 'pointer'
                    }}
                  />
                </Tooltip>
                <Tooltip title="Delete" placement="top" > 
                <DeleteOutlineIcon
                    id={"btn-toggleConfirmationDelete-" + i}
                    onClick={() => {
                      if (stat?.customers?.length === 0) {
                        setSegmentDeleteID(stat.id);
                        toggleConfirmationDelete();
                      } else {
                        const isStakeholders = stat.customers.filter(
                          (cus) => cus.stakeholders.length > 0
                        );
                        const message = isStakeholders
                          ? 'This segment is already assigned to the client(s) and stakeholder(s). Please remove both client(s) and stakeholder(s) before deleting this segment.'
                          : 'This segment is already assigned to the client(s). Please remove the client before deleting this segment.';

                        dispatch(
                          AppActions.toggleSnackBarOpen({
                            message,
                            severity: 'error'
                          })
                        );
                      }
                    }}
                    style={{
                      fontSize: '17px',
                      cursor: 'pointer'
                    }}
                  />
                </Tooltip>
                </>
                }
                </div>

                {expand && expandedCode === stat.code ? (
                  <ExpandLessIcon
                    id={"btn-expandTable-lessIcon-" + i}
                    onClick={() => expandTable(stat.code)}
                    style={{
                      fontSize: '27px',
                      cursor: 'pointer'
                    }}
                  />
                ) : (
                  <ExpandMoreIcon
                  id={"btn-expandTable-moreIcon-" + i}
                    onClick={() => expandTable(stat.code)}
                    style={{
                      fontSize: '27px',
                      cursor: 'pointer'
                    }}
                  />
                )}
              </CustomTableColumn>
              {expand && expandedCode === stat.code && (
                <Fragment>
                  <CustomTableColumn
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '1rem 2rem',
                      marginTop: '0.1rem',
                      borderBottomLeftRadius: '0',
                      borderBottomRightRadius: '0',
                      boxShadow: 'rgba(0, 0, 0, 0.1) 1.95px 0px 0px',
                    }}
                  >
                        {permissions.some(
                                (perm) =>
                                  perm.name === 'Edit Customer' && perm.value === true
                              ) && 

                <>
                    <Button
                      id={"btn-toggleCustomersAdd-" + i}
                      onClick={() => {
                        setCustomerEdit(false);
                        setSegmentId(stat.id);
                        setCustomerLength(stat?.customers?.length);
                        toggleCustomersAdd();
                        setSegmentName(stat.name);
                      }}
                      sx={{
                        mt: { xs: 2, md: 0 },
                        fontSize: '12px',
                        fontWeight: 'bold'
                      }}
                      variant="outlined"
                      startIcon={<AddTwoToneIcon fontSize="small" />}
                      style={{ height: '1.75rem', marginLeft: 'auto' }}
                    >
                      Create New
                    </Button>
                </>
        }
                  </CustomTableColumn>
                  <Card
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '1rem 2rem',
                      background: 'rgba(186, 206, 229, 0.2)',
                      borderRadius: '0',
                      boxShadow: 'rgba(0, 0, 0, 0.1) 1.95px 0px 0px',
                      borderLeft: '1px solid #D3D3D3'
                    }}
                  >
                    <Typography
                      style={{
                        color: '#232C68',
                        fontWeight: '700',
                        fontSize: '11px',
                        width: '10rem'
                      }}
                    >
                      {'Client Name'}
                    </Typography>
                    <Typography
                      style={{
                        color: '#232C68',
                        fontWeight: '700',
                        fontSize: '11px',
                        width: '8rem'
                      }}
                    >
                      {'Client Code'}
                    </Typography>
                    <Typography
                      style={{
                        color: '#232C68',
                        fontWeight: '700',
                        fontSize: '11px',
                        width: '8rem'
                      }}
                    >
                      {'Country'}
                    </Typography>
                    <Typography
                      style={{
                        color: '#232C68',
                        fontWeight: '700',
                        fontSize: '11px',
                        width: '8rem'
                      }}
                    >
                      {'Industry'}
                    </Typography>
                    <Typography
                      style={{
                        color: '#232C68',
                        fontWeight: '700',
                        fontSize: '11px',
                        width: '10rem'
                      }}
                    >
                      {'Engagement Lead'}
                    </Typography>
                    <Typography
                      style={{
                        color: '#232C68',
                        fontWeight: '700',
                        fontSize: '11px',
                        marginLeft: 'auto',
                        marginRight: '1rem'
                      }}
                    >
                      {'Actions'}
                    </Typography>
                  </Card>
                  {getCustomersInSegments(stat)}
                </Fragment>
              )}
            </Grid>
          ))}
        {paginatedSegments?.length === 0 && (
          <Typography
            style={{
              fontSize: '15px',
              fontWeight: 'bold',
              margin: '1rem',
              textAlign: 'center'
            }}
            variant="body2"
          >
            No Records Found
          </Typography>
        )}
        <Box p={2}>
          <TablePagination
            sx={{
              fontSize: '12px',
              '.MuiTablePagination-displayedRows': {
                fontSize: '12px'
              },
              '.MuiTablePagination-selectLabel': {
                fontSize: '12px'
              }
            }}
            component="div"
            count={filteredSegments?.length}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
          />
        </Box>
      </Grid>
      <SnackBar
        snackBarOpen={snackBarOpenS}
        setSnackBarOpen={setSnackBarOpenS}
        snackBarMessage={snackBarMessageS}
        snackbarSeverity={snackbarSeverityS}
      />
      <CustomerToggleModal
        open={openCustomers}
        toggle={toggleCustomersAdd}
        isEdit={customerEdit}
        getData={getTableData}
        data={customerEdit ? editDataCustomer : ''}
        length={customerLength}
        segmentId={segmentId}
        countries={countries}
        segmentName={segmentName}
        setSnackBarOpen={setSnackBarOpenS}
        setSnackbarSeverity={setSnackbarSeverityS}
        setSnackBarMessage={setSnackBarMessageS}
      />
      <StakeholderToggleModal
        open={openStakeHolders}
        toggle={toggleStakeholdersAdd}
        isEdit={stakeholdersEdit}
        getData={getTableData}
        data={stakeholdersEdit ? editDataStakeholder : ''}
        length={stakeholderLength}
        customerId={customerID}
        segmentId={segmentId}
        segments={segments}
        segmentName={segmentName}
        customerName={customerName}
        setSnackBarOpen={setSnackBarOpenS}
        setSnackbarSeverity={setSnackbarSeverityS}
        setSnackBarMessage={setSnackBarMessageS}
      />
      <SegmentToggleModal
        open={openCreateEdit}
        toggle={toggleCreateEdit}
        isEdit={isEdit}
        getData={getTableData}
        getSegmentData={()=>{}}
        data={isEdit ? editData : ''}
        length={segments?.length}
        setSnackBarOpenS={setSnackBarOpenS}
        setSnackbarSeverityS={setSnackbarSeverityS}
        setSnackBarMessageS={setSnackBarMessageS}
      />
      <ConfirmationModal
        isLoading={isLoading}
        open={openConfirmationDelete}
        toggle={toggleConfirmationDelete}
        message={`Are you sure want to delete this segment?`}
        onConfirm={() => deleteSegmentFunc()}
        noToggle={toggleConfirmationDelete}
      />
      <ConfirmationModal
        isLoading={isLoading}
        open={openConfirmationCustomerDelete}
        toggle={toggleConfirmationCustomerDelete}
        message={`Are you sure want to delete this client?`}
        onConfirm={() => deleteCustomerFunc()}
        noToggle={toggleConfirmationCustomerDelete}
      />
      <ConfirmationModal
        isLoading={isLoading}
        open={openConfirmationStakeholderDelete}
        toggle={toggleConfirmationStakeholderDelete}
        message={`Are you sure want to delete this stakeholder?`}
        onConfirm={() => deleteStakeholderFunc()}
        noToggle={toggleConfirmationStakeholderDelete}
      />
    </Fragment>
  );
};

export default SegmentRows;
